module.exports = __webpack_public_path__ + "webpc/img/icon_gz_4.248e79f2.png";